import React from 'react'
import { containerStyles4 } from './addingcontent/VissionMission'
import { Box, CardContent, CardMedia, Grid, useMediaQuery, useTheme } from '@mui/material'
import { TypographyText } from '../Reuse/Reuse'

const Content3Services = () => {
   const theme = useTheme();
      
       const matches2 = useMediaQuery(theme.breakpoints.up("sm"));
  return (
    <div>
                       <Box sx={containerStyles4}
                       id="ourservices">
        <Grid container spacing={4} >
      
        <Grid item xs={12} lg={12} md={12} sm={12} sx={{textAlign:'center'}} >
      
      <TypographyText
          Typography={<>Our Services
           
          </>}
          variant={matches2 ? "h4" : "h5"}
     
            textAlign="centre"
            color ='white'
        />  

      </Grid>
      {/* <CardMedia
                    component="img"
                    height="200"
                    image={data.image}
                    alt={data.txt}
                    sx={{
                      objectFit: !isSmallScreen ? "contain" : "contain;",
                    }}
                  />
                  <CardContent>
                    <TypographyText
                      Typography={data.txt}
                      fontSize={"1.5rem"}
                      textAlign="center"
                      color="white"
                    />
                    </CardContent> */}
                    {Data.map((data,index)=>(
          <Grid 
          item xs={12} lg={3} md={6} sm={6} >

<CardMedia
                    component="img"
                    height="150"
                    image={data.image}
                    alt={data.txt}
                    // sx={{
                    //   objectFit: !isSmallScreen ? "contain" : "contain;",
                    // }}
                  />
                  <CardContent>
                    <TypographyText
                      Typography={data.txt}
                      fontSize={"1.5rem"}
                      textAlign="center"
                      color="white"
                    />
                    </CardContent> 
          </Grid>
        ))}
        </Grid>
      </Box>  


       

    </div>
  )
}

export default Content3Services
const Data=[{
  image:"https://alp.consulting/wp-content/uploads/2024/05/What-are-Patient-Support-Programs-min.webp",
  txt:"Patient Support Programs",

},
{
  image:"https://www.thehighereducationreview.com/newnews/Dcf9OxGp.jpg",
  txt:"Research and development",
},
{
  image:"https://nationalpublictrust.com/wp-content/uploads/2022/10/public-Awareness-min-800x580.jpg",
  txt:"Awareness Initiatives"
},
{
  image:"https://www.ppd.com/wp-content/uploads/2023/01/peri-post-approval_1488114713.jpg",
  txt:"Access to life saving therapies"
}]